import React from 'react';
import { NavLink } from 'react-router-dom';
import './Nav.css';

const Nav = (props) => {

    return (
        <nav>
          <ul>
            <li><NavLink to='/'>Home</NavLink></li>
            <li><NavLink to='/activities'>Activities</NavLink></li>
            <li><NavLink to='/team'>Team</NavLink></li>
            <li><NavLink to='/profile'>Profile</NavLink></li>
          </ul>
        </nav>
    )
}

export default Nav;